import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Form from "react-validation/build/form.js";
import { Card, CardBody, Input } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import "../../assets/custom css/loadoverlay.scss";
import Alerts from "../../components/Alerts/alerts.js";
import ItemService from "./Item.service.js";
import AuthService from "../Authentication/auth.service.js";
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { createGlobalStyle } from 'styled-components';
import PermissionAccess from '../../PermissionAccess/Access.js';
import Select from 'react-select';

const MAX_IMAGE_SIZE_BYTES = 650 * 1024;
const MAX_TOTAL_BODY_BYTES = 950 * 1024;

const imageStyle = {
  width: 'auto',
  height: '200px',
  objectFit: 'cover',
  margin: '0px auto',
};

const slideStyle = {};

const customSliderStyles = `
  .slick-prev,
  .slick-next {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    z-index: 1;
  }

  .slick-prev:hover,
  .slick-next:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: white;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${customSliderStyles}
`;

const DriverInsertionForm = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const form = useRef();
  const [pre_params, setpre_params] = useState('');
  const [collectionlist, setcollectionlist] = useState([]);
  const [fieldlist, setfieldlist] = useState([]);
  const [item_name, setItem_name] = useState('');
  const [item_code, setItem_code] = useState('');
  const [portal, setPortal] = useState('');
  const [description, setDescription] = useState('');
  const [BaseUOM, setBaseUOM] = useState('');
  const [price, setPrice] = useState('');
  const [weight, setWeight] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [errors, setErrors] = useState({});
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const [categoryError, setCategoryError] = useState('');
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [Category, setCategory] = useState('');
  //iph todo: 47
  //console.log("categories", categories)
  const estimateIncomingBodyBytes = (files) =>
    (files || []).reduce((total, file) => total + Math.ceil(file.size * 4 / 3) + 100, 0);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = null;
    if (files.length === 0) return;

    const oversized = files.filter((file) => file.size > MAX_IMAGE_SIZE_BYTES);
    if (oversized.length > 0) {
      const names = oversized.map((f) => `${f.name} (${(f.size / 1024).toFixed(0)}KB)`).join(', ');
      const message = `Image provided must be less than 650KB. Rejected: ${names}`;
      setErrors((prev) => ({ ...prev, images: message }));
      Alerts.swalErrorAlert(t(message));
    }

    const validFiles = files.filter((file) => file.size <= MAX_IMAGE_SIZE_BYTES);
    if (validFiles.length === 0) {
      return;
    }

    const incomingBodyBytes = estimateIncomingBodyBytes(validFiles);
    if (incomingBodyBytes > MAX_TOTAL_BODY_BYTES) {
      const message = "Total images size too large. Please use smaller files (total must stay under ~950KB) to fit the 1MB server limit.";
      setErrors((prev) => ({ ...prev, images: message }));
      Alerts.swalErrorAlert(t(message));
      return;
    }

    setErrors((prev) => {
      const next = { ...prev };
      if (oversized.length === 0) delete next.images;
      else if (validFiles.length > 0) delete next.images;
      return next;
    });
    const imageUrls = validFiles.map(file => URL.createObjectURL(file));
    setSelectedImages(imageUrls);
  };

  const validateForm = () => {
    let formErrors = {};

    if (!item_name.trim()) formErrors.item_name = "Item Name is required";
    if (!BaseUOM.trim()) formErrors.BaseUOM = "Base UOM is required";
    if (!item_code.trim()) formErrors.item_code = "Item Code is required";
    if (!portal.trim()) formErrors.portal = "Portal is required";
    if (!description.trim()) formErrors.description = "Description is required";
    if (!price) formErrors.price = "Price is missing for that item";
    // if (!weight) formErrors.weight = "Weight is required";
    if (!Category) formErrors.Category = "Category is required";
    // if (selectedImages.length === 0) { formErrors.images = "At least one image is required"; }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const sliderStyle = {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
  }

  const ImageSlideshow = ({ images }) => {
    if (images.length === 1) {
      return (
        <div style={{ ...sliderStyle, textAlign: 'center' }}>
          <img src={images[0]} alt="Single Image" style={imageStyle} />
        </div>
      );
    }

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
    };


    return (
      <div style={sliderStyle}>
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} style={slideStyle}>
              <img src={image} alt={`Slide ${index + 1}`} style={imageStyle} />
            </div>
          ))}
        </Slider>
      </div>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchCategory(0, 99999);
  }, []);


  function fetchCategory(page_index, page_limit) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    const stored_user = authData.userData;
    let business = []
    if (stored_user.businesses) {
      business = stored_user.businesses
    }

    var getData = {
      functionName: "GetCategoryDropDown",
      "postData": {
        "offset": offset,
        "sort": {
          "_id": -1
        },
        "limit": page_limit,
        business_id: business,
        "noActiveMatch": true
      }
    }
    setLoading(true);
    ItemService.GetCategories(getData, authData.sessionID,).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Category response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setCategories(response.data.data.data);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };


  async function handleSubmit(e) {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    var requestData = {};
    var field_errors = [];

    const base64Images = await Promise.all(selectedImages.map(async (imageUrl) => {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onloadend = () => {
          const base64String = reader.result;
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }));

    const totalBodyBytes = base64Images.reduce(
      (total, img) => total + (typeof img === 'string' ? img.length : 0),
      0
    );
    if (totalBodyBytes > MAX_TOTAL_BODY_BYTES) {
      const message = `Total images size too large (${(totalBodyBytes / 1024).toFixed(0)}KB). Each image must be less than 650KB and total must stay under ~950KB to fit the 1MB server limit. Please remove or replace images.`;
      setErrors((prev) => ({ ...prev, images: message }));
      Alerts.swalErrorAlert(t(message));
      return;
    }
    const stored_user = authData.userData;
    let business = []
    if (stored_user.businesses) {
      business = stored_user.businesses
    }
    requestData.functionName = "AddItems";
    requestData.formId = collectionlist._id;
    requestData.user_type_id = collectionlist._id;
    requestData.Images = base64Images;
    requestData.BaseUOM = BaseUOM;
    requestData.item_name = item_name;
    requestData.item_code = item_code;
    requestData.portal = portal;
    requestData.description = description;
    requestData.price = price;
    requestData.weight = weight || 0;
    requestData.business_id = business;
    requestData.category = Category;
    requestData.status = 'Active';

    if (field_errors.length === 0) {
      setLoading(true);
      ItemService.save_item(requestData, authData.sessionID)
        .then((response) => {
          setLoading(false);
          if (response.data.status) {
            navigate("/items-list");
            if (response.data.message) {
              Alerts.swalSuccessAlert(response.data.message);
            } else {
              Alerts.swalSuccessAlert("Data added successfully.");
            }
          } else {
            if (response.data.message === "Unauthorized") {
              AuthService.logout();
              navigate("/login");
              window.location.reload();
            } else {
              Alerts.swalErrorAlert(response.data.message || "Error: Can't add data at the moment. Please try again later.");
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          Alerts.swalErrorAlert("Network Operation failed.");
        });
    }
  }

  return (
    <>
      <GlobalStyle />
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="app-page-title">
            <div className="page-title-wrapper justify-content-left">
              <div className="page-title-heading fw-bold">
                <div className="page-title-icon">
                  <i className="pe-7s-plus icon-gradient bg-happy-green" />
                </div>
                <div>
                  {t("Add Items")}
                  <div className="page-title-subheading">
                    {t('Fill the form below to add Items')}.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="col-md-6">
              <Card className="main-card mb-3">
                <CardBody>
                  <LoadingOverlay
                    tag="div"
                    active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}
                  >
                    <Form onSubmit={handleSubmit} ref={form}>
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="item_name">{t("Item Name")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              type='text'
                              value={item_name}
                              onChange={(e) => setItem_name(e.target.value)}
                              className={`form-control ${errors.item_name ? 'is-invalid' : ''}`}
                              placeholder={t("Item Name")}
                              name="item_name"
                              id="item_name"
                            />
                            {errors.item_name && <div className="invalid-feedback">{errors.item_name}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="item_code">{t("Item Code")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              type='text'
                              value={item_code}
                              onChange={(e) => setItem_code(e.target.value)}
                              className={`form-control ${errors.item_code ? 'is-invalid' : ''}`}
                              placeholder={t("Item Code")}
                              name="item_code"
                              id="item_code"
                            />
                            {errors.item_code && <div className="invalid-feedback">{errors.item_code}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="portal">{t("Portal")} <span style={{ color: "red" }}>*</span></label>
                            <Input
                              type='select'
                              value={portal}
                              onChange={(e) => setPortal(e.target.value)}
                              className={`form-control ${errors.portal ? 'is-invalid' : ''}`}
                              placeholder={t("Portal")}
                              name="portal"
                              id="portal"
                            >
                              <option value="" disabled>{t("Select Portal")}</option>
                              <option value="customers">{t("Customers Portal")}</option>
                              <option value="doctors">{t("Doctors Portal")}</option>
                              <option value="both">{t("Both")}</option>
                            </Input>
                            {errors.portal && <div className="invalid-feedback">{errors.portal}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="BaseUOM">{t("Base UOM")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              type='text'
                              value={BaseUOM}
                              onChange={(e) => setBaseUOM(e.target.value)}
                              className={`form-control ${errors.BaseUOM ? 'is-invalid' : ''}`}
                              placeholder={t("Base UOM")}
                              name="BaseUOM"
                              id="BaseUOM"
                            />
                            {errors.BaseUOM && <div className="invalid-feedback">{errors.BaseUOM}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="description">{t("Description")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              type='text'
                              className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                              placeholder={t("Description")}
                              name="description"
                              id="description"
                            />
                            {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="price">{t("Price")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              value={price}
                              onChange={(e) => setPrice(e.target.value)}
                              type='number'
                              className={`form-control ${errors.price ? 'is-invalid' : ''}`}
                              placeholder={t("Price")}
                              name="price"
                              id="price"
                            />
                            {errors.price && <div className="invalid-feedback">{errors.price}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="weight">{t("Weight (Grams)")}</label>
                            <input
                              value={weight}
                              onChange={(e) => setWeight(e.target.value)}
                              type='number'
                              className={`form-control ${errors.weight ? 'is-invalid' : ''}`}
                              placeholder={t("Weight (Grams)")}
                              name="weight"
                              id="weight"
                            />
                            {errors.weight && <div className="invalid-feedback">{errors.weight}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="Category">
                              {t("Category")} <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              id="Category"
                              name="Category"
                              options={categories.map(category => ({ value: category._id, label: category.Name }))}
                              value={categories.find(option => option._id === Category) ? { value: Category, label: categories.find(option => option._id === Category)?.Name } : null}
                              onChange={option => setCategory(option ? option.value : '')}
                              placeholder={t("Select Category")}
                              isClearable
                              classNamePrefix="react-select"
                              className={errors.Category ? 'is-invalid' : ''}
                            />
                            {errors.Category && (
                              <div className="invalid-feedback" style={{ display: 'block' }}>{errors.Category}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row" key={'images'}>
                        <div className="col-md-12 col-xl-12" >
                          <div className="form-group" >
                            <label htmlFor="name">Images
                            </label>
                            <small className="form-text text-muted d-block mb-1">{t("Image provided must be less than 650KB")}</small>
                            <input
                              type='file'
                              accept="image/*"
                              multiple
                              className={`form-control ${errors['images'] ? 'is-invalid' : ''}`}
                              placeholder={'Images'}
                              name={'images'}
                              id={'images'}
                              onChange={handleFileChange}
                            />
                            {errors['images'] && (
                              <div className="invalid-feedback">{errors['images']}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <br />
                      {selectedImages.length > 0 && (
                        <div className="row">
                          <div className="col-md-12 col-xl-12">
                            <ImageSlideshow images={selectedImages} />
                          </div>
                        </div>
                      )}
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12" >
                          <center>
                            <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-light btn-hover-shine me-3 mt-3">{t('Cancel')}</button>
                            <button className="btn btn-custom-color btn-hover-shine me-3 mt-3" >{t('Add data')}</button>
                          </center>
                        </div>
                      </div>
                    </Form>
                  </LoadingOverlay>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );


}

export default DriverInsertionForm;